<template>
  <div>
    <div v-if="!loading">
      <div ref="test" class="row" style="margin: 0px">
        <div v-if="!isMobile() && items.length > 0 && sidebarModes.includes(filter_mode)" class="col" style="overflow-y:scroll; max-height: 900px; max-width: 360px; border: 1px solid grey;">
          <div v-if="route_name_options.length > 2" style="margin:10px; font-size: 20px; font-weight: bold" class="d-flex align-items-center justify-content-center">
            {{filter_type === 'vehicle' ? 'Unit:' : 'Route:'}}&nbsp;<b-form-select v-model="selected_route_name" :options="route_name_options" style="font-size: 16px; width:260px"/>
          </div>
          <div v-if="items.length > 0" @click="toggle_div(veh, veh.name,'detailsVisible')" v-for="(veh,idx) in items" style="font-size: 18px;text-align: left; padding:10px">
            <span v-if="veh.gps.speedMilesPerHour == 0" style="color: darkred; font-size: 18px; font-weight: bold">{{veh.name | trim(30)}}</span>
            <span v-else style="color: green; font-size: 18px; font-weight: bold">{{veh.name | trim(25)}}</span>
            <span v-if="veh.route_name" style="font-size: 16px; font-weight: bold"> - {{veh.route_name}}</span>
            <br/>
          </div>
          <div v-if="items.length == 0" style="font-size: 18px;border-top: 1px solid grey; text-align: left; padding:10px">
            <span v-if="!summary.route_names || summary.route_names.length == 0" style="color: darkred; font-size: 18px; font-weight: bold">no {{filter_value}} vehicle routes are currently in service</span>
          </div>
        </div>
        <div v-if="items.length > 0" class="col" style="border: none; padding-right:0px !important; padding-left:0px !important">
          <div v-if="isMobile() && sidebarModes.includes(filter_mode)" style="margin:5px; font-size: 20px; font-weight: bold" class="d-flex align-items-center justify-content-center">
            {{filter_type === 'vehicle' ? 'Unit:' : 'Route:'}}&nbsp;<b-form-select v-model="selected_route_name" :options="route_name_options" style="font-size: 18px; width:250px"/>
          </div>
          <GmapMap id="map" ref="mapRef"
                   :zoom="zoom"
                   :center="center"
                   :options="mapStyle"
                   style="width:100%;  height: 900px;"
          >
            <GmapMarker
                v-for="(marker, idx) in markers"
                :key="idx"
                :position="marker.position"
                :title="marker.title"
                :label="marker.label"
                :draggable="false"
                :clickable="true"
                :icon="marker.icon"
                :zIndex="marker.zIndex"
                @mouseover="openInfoWindowTemplate(marker.title)"
                @mouseout="infoWindow.open=false"
            />
            <GmapInfoWindow
                :options="{pixelOffset: { width: 0, height: -65 }}"
                :position="infoWindow.position"
                :opened="infoWindow.open"
            >
              <div v-html="infoWindow.template"></div>
            </GmapInfoWindow>

          </GmapMap>
        </div>
        <div v-else-if="filter_mode=='booking' || filter_mode=='bookingETA' || filter_mode=='movement' || filter_mode=='tbnBookingID' || filter_mode=='vehicleAssignmentID'" class="vmt-center-message">
          <h3>Live tracking is not active right now</h3>
          <div class="vmt-submessage">tracking is available {{summary.minutes_before}} minutes before the charter starts through {{summary.minutes_after}} minutes after completion</div>
          <div class="vmt-submessage">this page will update automatically once tracking starts</div>
        </div>
        <div style="padding: 20px; font-weight: bold; font-size: 22px" v-else>
          <b>vehicle locations are currently unavailable</b>
        </div>
      </div>
    </div>
    <div v-if="loading">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>
</template>
<script>
import {get_vehicle_track_fleet, get_vehicle_track_reload} from '../networking/apis'
import {get_vehicle_track_fleet_tbn} from '../networking/tbn_apis'

export default {
  name: 'vehicle_map_track_fleet',
  components: {
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      tenant_id: null,
      filter_mode: '',
      filter_value: '',
      items: [],
      items_full: [],
      tenant_type: 'CM',
      loading: true,
      reload_enabled: true,
      follow_enabled: true,
      center: null,
      zoom: null,
      markers: [],
      markers_full: [],
      reload_interval: 10000,
      bounds: null,
      timer: null,
      reload_inflight: false,
      selected_route_name: '',
      route_name_options: [],
      filter_type: 'route',
      icon_mode: 'arrow', // 'arrow' or 'bus'
      infoWindow: {
        position: {lat: 0, lng: 0},
        open: false,
        template: ''
      },
      mapStyle: {
        styles: [
          {
            "featureType": "landscape",
            "stylers": [
              { "color": "#F3F4F9" }
            ]
          },          {
            "featureType": "water",
            "stylers": [
              { "color": "#C1CDE4" }
            ]
          },
          {
            "featureType": "landscape.natural.terrain",
            "stylers": [
              { "color": "#E0EDCA" }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [{color: '#DDDDDD'}]
          },
          {
            featureType: 'road',
            elementType: 'geometry.fill',
            stylers: [{color: '#FFFFFF'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [{color: '#FEF8D6'}]
          },
          {
            featureType: 'transit',
            stylers: [{"visibility": "off"}]
          },
          {
            featureType: 'poi',
            stylers: [{"visibility": "off"}]
          },
        ]
      }
    }
  },
  async created() {
    this.check_features()
  },
  async mounted () {
    this.stopTimer();
  },
  beforeDestroy() {
    this.stopTimer();
  },
  methods: {
    startTimer() {
      this.stopTimer();
      this.timer = setInterval(() => this.reload_data(), this.reload_interval);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    async resetTimerAndReload() {
      this.stopTimer();
      await this.reload_data();
      this.startTimer();
    },

    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    computeMarkerZIndex(position, base) {
      const zBase = Number.isFinite(base) ? base : 0;
      const lat = position && position.lat != null ? Number(position.lat) : 0;
      let latKey = Math.round((90 - lat) * 1000);
      if (!Number.isFinite(latKey)) latKey = 0;
      return zBase + latKey;
    },
    async check_features() {

      // Check for icon mode in the path (e.g., /busicon) and remove it before parsing
      let pathAfterFleetTrack = this.$route.path.split('/fleet-track/')[1]
      if (pathAfterFleetTrack && pathAfterFleetTrack.includes('busicon')) {
        this.icon_mode = 'bus'
        // Remove busicon from the path string
        pathAfterFleetTrack = pathAfterFleetTrack.replace(/\/busicon\/?/g, '/').replace(/^\/+|\/+$/g, '')
      }
      
      this.tenant_id = pathAfterFleetTrack.split("/")[0]
      this.filter_mode = pathAfterFleetTrack.split("/")[1]
      this.filter_value = pathAfterFleetTrack.split("/")[2]
      if (pathAfterFleetTrack.split("/").length > 4) {
        this.filter_value += '/' + pathAfterFleetTrack.split("/")[3]
        this.tenant_type = pathAfterFleetTrack.split("/")[4]
      }
      else if (pathAfterFleetTrack.split("/").length > 3)
        this.tenant_type = pathAfterFleetTrack.split("/")[3]

      if (this.filter_mode == 'yard') {
        this.mapStyle = { "mapTypeId": "satellite", "tilt": 0 }
        this.reload_interval = 60000
      }
      else if (this.filter_mode == 'vsm') {
        this.reload_interval = 60000
      }
      else if (this.filter_mode == 'bookingETA') {
        this.reload_interval = 120000
      }
      else if (this.filter_mode == 'fullfleetoverview') {
        this.reload_interval = 120000
      }
      else if (this.filter_mode == 'routes') {
        this.reload_interval = 15000
      }

      this.load_data()
    },
    openInfoWindowTemplate(selected_name) {
      const loc = this.items.filter(item => item.name == selected_name)[0]

      if (loc != null) {
        const position = {
          lat: Number(loc.gps.latitude),
          lng: Number(loc.gps.longitude),
        };
        this.infoWindow.position = position
        this.infoWindow.template = loc.marker_html
        this.infoWindow.open = true
      }
    },
    toggle_div(item,selected_name,field) {
      // item[field] = !item[field];
      // this.$forceUpdate();

      const loc = this.items.filter(item => item.name == selected_name)[0]
      if (loc != null) {
        this.center = {
          lat: Number(loc.gps.latitude),
          lng: Number(loc.gps.longitude),
        };
        this.zoom = 13
      }
    },
    async load_data() {
      this.loading = true
      try {
        let results = null;

        if (this.tenant_type=='CM')
          results = await get_vehicle_track_fleet(this.tenant_id,this.filter_mode,this.filter_value)
        else
          results = await get_vehicle_track_fleet_tbn(this.tenant_id,this.filter_mode,this.filter_value)

        const {value: { data = [] } } = results

        this.summary = data.summary
        this.filter_type = data.summary.filter_type || 'route'
        this.route_name_options = data.summary.route_names
        this.items = data.results
        this.items_full = data.results

        if (this.summary.map_center) {
          this.center = {
            lat: Number(this.summary.map_center.split(",")[0]),
            lng: Number(this.summary.map_center.split(",")[1]),
          }
        }

        if (this.items.length == 0) {
          const position = {
            lat: Number('39.917742615494085'),
            lng: Number('-97.13906071185122'),
          };
          if (this.center == null)
            this.center = position;

          this.zoom = this.summary.zoom

          this.loading = false;
        } else {
          if (this.items && this.items.length > 0) {
            let idx = 0
            for (const loc of this.items) {
              idx += 1
              const position = {
                lat: Number(loc.gps.latitude),
                lng: Number(loc.gps.longitude),
              };
              if (this.center == null)
                this.center = position;
              
              let marker_title = loc.name

              if (this.filter_mode == 'yard')
                marker_title = loc.name

              if (loc.route_name != null) {
                marker_title += " - " + loc.route_name;
              }

              if (loc.pickup_address) {
                const pickup_position = {
                  lat: Number(loc.pickup_lat),
                  lng: Number(loc.pickup_lon),
                };
                this.markers.push({position: pickup_position, title: 'pickup', label: {text: loc.pickup_address, className: 'addr-label-' + idx}, icon: this.mapSymbol("green"), zIndex: this.computeMarkerZIndex(pickup_position, 0)});
              }

              if (loc.destination_address) {
                const destination_position = {
                  lat: Number(loc.destination_lat),
                  lng: Number(loc.destination_lon),
                };
                this.markers.push({position: destination_position, title: 'destination', label: {text: loc.destination_address, className: 'addr-label-' + idx}, icon: this.mapSymbol("orange"), zIndex: this.computeMarkerZIndex(destination_position, 0)});
              }

              if (loc.dropoff_address && (loc.dropoff_lat != loc.pickup_lat && loc.dropoff_lon != loc.pickup_lon)) {
                const pickup_position = {
                  lat: Number(loc.dropoff_lat),
                  lng: Number(loc.dropoff_lon),
                };
                this.markers.push({position: pickup_position, title: 'dropoff', label: {text: loc.dropoff_address, className: 'addr-label-' + idx}, icon: this.mapSymbol("red"), zIndex: this.computeMarkerZIndex(pickup_position, 0)});
              }

              if (loc.eta)
                marker_title += " (" + loc.eta + ")"

              var label = {text: marker_title, className: 'tracking-label'}

              if (this.filter_mode=='pickup')
                label = ""

              this.markers.push({
                position: position,
                heading: loc.gps.headingDegrees,
                title: marker_title,
                bus_name: loc.name,
                route_name: loc.route_name,
                label: label,
                icon: this.arrowSymbol(loc.gps),
                zIndex: this.computeMarkerZIndex(position, 1000000000)
              });

            }
          }

          this.markers_full = this.markers
          this.loading = false

          if (this.markers.length > 1 && this.filter_mode != 'pickup')
            this.fitMapToMarkers()
          else
            this.zoom = this.summary.zoom
        }

        this.startTimer();

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

    },
    async fitMapToMarkers() {
      if (!this.$refs.mapRef) {
        let cnt=0;
        while(cnt<10) {
          if (this.$refs.mapRef)
            break;
          await this.sleep(500);
          console.log("waiting for mapref: " + cnt)
          cnt++;
        }
      }

      this.bounds = new google.maps.LatLngBounds();
      for (const marker of this.markers)
        this.bounds.extend(marker.position);

      this.$refs.mapRef.$mapObject.fitBounds(this.bounds);
    },
    async reload_data() {
      console.log("reload_data()")
      try {
        if (this.$pageVisibility && this.$pageVisibility.hidden) {
          return
        }

        if (!this.reload_enabled) {
          console.log("reload disabled")
          return
        }

        if (this.reload_inflight) {
          console.log("reload already in-flight; skipping");
          return;
        }
        this.reload_inflight = true;

        let results = null;

        if (this.tenant_type=='CM')
          results = await get_vehicle_track_reload(this.tenant_id,this.filter_mode,this.filter_value)
        else
          results = await get_vehicle_track_fleet_tbn(this.tenant_id,this.filter_mode,this.filter_value)

        const {value: { data = [] } } = results

        if (data.results.length === 0) {
          return;
        }

        this.summary = data.summary
        this.filter_type = data.summary.filter_type || 'route'
        this.items = data.results
        this.items_full = data.results
        this.route_name_options = data.summary.route_names

        if (this.items.length == 0) {
          return;
        }

        this.filter_items()
        if (this.items && this.items.length > 0) {
          let idx = 0
          for (const loc of this.items) {
            idx += 1
            const position = {
              lat: Number(loc.gps.latitude),
              lng: Number(loc.gps.longitude),
            };

            let current_marker_idx = this.markers.findIndex(x => x.bus_name === loc.name);
            let pickup_idx = this.markers.findIndex(x => x.title === 'pickup');
            let destination_idx = this.markers.findIndex(x => x.title === 'destination');
            let dropoff_idx = this.markers.findIndex(x => x.title === 'dropoff');

            let marker_title = loc.name;
            if (loc.route_name != null)
              marker_title += " - " + loc.route_name;

            if (loc.eta)
              marker_title += " (" + loc.eta + ")"

            var label = {text: marker_title, className: 'tracking-label'}

            if (this.filter_mode=='pickup')
              label = ""

            if (pickup_idx != -1) {
              this.markers[pickup_idx].label = {text: loc.pickup_address, className: 'addr-label-' + idx};
              this.markers[destination_idx].label = {text: loc.destination_address, className: 'addr-label-' + idx};
              this.markers[dropoff_idx].label = {text: loc.dropoff_address, className: 'addr-label-' + idx};
            }

            if (current_marker_idx == -1) {
              this.markers.push({position: position, heading: loc.gps.headingDegrees, title: marker_title, bus_name: loc.name, route_name: loc.route_name, label: label, icon: this.arrowSymbol(loc.gps), zIndex: this.computeMarkerZIndex(position, 1000000000)});
              current_marker_idx = this.markers.findIndex(x => x.bus_name === loc.name);
            } else {
              if (marker_title != this.markers[current_marker_idx].title) {
                this.markers[current_marker_idx].label = label;
              }
            }

            this.animatedMove(this.markers[current_marker_idx], loc.gps);
          }
        }

        //remove any markers that no longer exist
        let markers_to_remove = []
        for (const old_marker of this.markers) {
          let marker_idx = this.items.findIndex(x => x.name === old_marker.bus_name);
          if (marker_idx == -1 && old_marker.bus_name.indexOf('pickup') == -1)
            markers_to_remove.push(old_marker.bus_name);
        }
        if (markers_to_remove.length > 0) {
          console.log("markers_to_remove:" + markers_to_remove);
          this.markers = this.markers.filter(item => !markers_to_remove.includes(item.bus_name))
        }

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      } finally {
        this.reload_inflight = false;
      }

    },
    animatedMove(marker, new_loc) {

      const new_position = {
        lat: Number(new_loc.latitude),
        lng: Number(new_loc.longitude),
      };

      let new_heading = Number(new_loc.headingDegrees);
      let old_heading = marker.icon.rotation;

      //console.log("heading change: old = " + old_heading + ", new = " + new_heading);

      if (this.icon_mode === 'bus') {
        // Bus mode: extract original GPS heading from display rotation (remove 270° adjustment)
        if (marker.icon && marker.icon.rotation !== undefined) {
          old_heading = (marker.icon.rotation - 270 + 360) % 360;
        }
        // When stopped in bus mode, lock heading - don't update from GPS data
        const isStopped = new_loc.speedMilesPerHour == 0;
        if (isStopped && marker.icon && marker.icon.rotation !== undefined) {
          new_heading = old_heading; // Use current heading, don't update
        }
      }

      if (new_heading == 0)
        new_heading = marker.icon.rotation;
      if (old_heading == 0 || isNaN(old_heading)) {
        if (this.icon_mode === 'bus') {
          // For bus mode, regenerate the icon with correct heading
          new_loc.headingDegrees = new_heading;
          marker.icon = this.busSymbol(new_loc);
        } else {
          marker.icon.rotation = new_heading;
        }
      }

      marker.speed = new_loc.speedMilesPerHour;

      if (this.icon_mode === 'bus') {
        // Bus mode: Update icon immediately if speed status changed (moving <-> stopped)
        const old_speed = marker.speed || 0
        const wasMoving = old_speed > 0
        const isMoving = new_loc.speedMilesPerHour > 0
        if (wasMoving !== isMoving) {
          const isStopped = new_loc.speedMilesPerHour == 0;
          // When stopping, preserve the last heading to prevent flipping
          if (isStopped && marker.icon && marker.icon.rotation !== undefined) {
            // Preserve the current rotation - just update the color, don't change heading
            const preservedRotation = marker.icon.rotation;
            marker.icon = this.busSymbol(new_loc);
            // Override rotation to preserve the last heading when stopped
            marker.icon.rotation = preservedRotation;
          } else {
            // Use busSymbol to get the correct icon with proper rotation
            marker.icon = this.busSymbol(new_loc);
          }
        }
      }

      var delta_incr = 200;

      var deltalat = (new_position.lat - marker.position.lat) / delta_incr;
      var deltalng = (new_position.lng - marker.position.lng) / delta_incr;
      
      if (this.icon_mode === 'bus') {
        // Bus mode: Calculate heading difference using GPS headings (0-360)
        let heading_diff = new_heading - old_heading;
        
        // Handle wraparound - take shortest path around circle
        if (heading_diff > 180) {
          heading_diff = heading_diff - 360;
        } else if (heading_diff < -180) {
          heading_diff = heading_diff + 360;
        }
        
        // Ignore small changes to prevent jitter/flipping
        var deltaheading = 0;
        var direction = 'clockwise';
        const isStopped = new_loc.speedMilesPerHour == 0;
        if (Math.abs(heading_diff) >= 5 && !isStopped) {
          deltaheading = heading_diff / delta_incr;
          direction = heading_diff > 0 ? 'clockwise' : 'counterclockwise';
        }
      } else {
        // Arrow mode: original logic unchanged
        var deltaheading = (new_heading - marker.icon.rotation) / delta_incr;

        var direction = 'clockwise';
        if (new_heading > old_heading) {
          if ((new_heading - old_heading) > 180) {
            direction = 'counterclockwise';
            deltaheading = (old_heading + (360-new_heading)) / delta_incr;
          } else {
            deltaheading = (new_heading - old_heading) / delta_incr;
          }
        } else if (old_heading > new_heading) {
          if ((old_heading - new_heading) > 180) {
            direction = 'clockwise';
            deltaheading = (new_heading + (360-old_heading)) / delta_incr;
          } else {
            direction = 'counterclockwise';
            deltaheading = (old_heading - new_heading) / delta_incr;
          }
        }

        if (Math.abs(old_heading - new_heading) < 2)
          deltaheading = 0;
      }

      //console.log("direction: " + direction + ":" + Math.round(deltaheading * delta_incr));

      var delay = this.reload_interval/delta_incr;

      //console.log("heading adjust: old = " + Number(old_heading) + ", new = " + Number(new_heading) + ", deltas: lat " + deltalat + ", lon " + deltalng + ", heading: " + deltaheading + ", delay: " + delay);

      const iconMode = this.icon_mode; // Capture icon_mode to use in closure
      let busSymbolFn, isStoppedValue, oldGpsHeading, newGpsHeading, headingDiffAdjusted;
      if (this.icon_mode === 'bus') {
        // Bus mode: Capture variables for closure
        busSymbolFn = this.busSymbol.bind(this);
        isStoppedValue = new_loc.speedMilesPerHour == 0;
        oldGpsHeading = old_heading;
        newGpsHeading = new_heading;
        let heading_diff = new_heading - old_heading;
        if (heading_diff > 180) {
          heading_diff = heading_diff - 360;
        } else if (heading_diff < -180) {
          heading_diff = heading_diff + 360;
        }
        headingDiffAdjusted = heading_diff;
      }
      
      for (var i = 0; i < delta_incr; i++) {
        (function(ind) {
          setTimeout(
              function() {
                let incr_position = {
                  lat: (marker.position.lat + deltalat),
                  lng: (marker.position.lng + deltalng),
                };
                marker.position = incr_position;

                if (iconMode === 'bus') {
                  // Bus mode: always regenerate bus icon during animation to ensure it never reverts to arrow
                  // Work with original GPS headings, interpolate between old and new
                  let current_gps_heading = oldGpsHeading;
                  
                  // Only update heading when moving (not stopped)
                  if (deltaheading != 0 && !isStoppedValue) {
                    // Calculate progress through animation (0 to 1)
                    const progress = (ind + 1) / delta_incr;
                    // Use the pre-calculated adjusted heading difference
                    current_gps_heading = (oldGpsHeading + headingDiffAdjusted * progress + 360) % 360;
                  }
                  
                  const updated_loc = {
                    latitude: new_loc.latitude,
                    longitude: new_loc.longitude,
                    speedMilesPerHour: new_loc.speedMilesPerHour,
                    headingDegrees: current_gps_heading
                  };
                  marker.icon = busSymbolFn(updated_loc);
                } else {
                  // Arrow mode: original logic unchanged
                  if (deltaheading != 0) {
                    let new_rotation;
                    if (direction == 'clockwise')
                      new_rotation = Number(marker.icon.rotation + deltaheading);
                    else
                      new_rotation = Number(marker.icon.rotation - deltaheading);

                    if (new_rotation > 360) {
                      new_rotation = 0;
                    }

                    // Only regenerate icon when rotation changes significantly
                    if (Math.floor(marker.icon.rotation) != Math.floor(new_rotation)) {
                      marker.icon.rotation = new_rotation;
                      marker.icon =
                          {
                            path: (new_loc.speedMilesPerHour == 0 || new_heading == 0) ? "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0" : "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
                            scale: 1.5,
                            strokeColor: "white",
                            strokeStyle: "bold",
                            fillColor: new_loc.speedMilesPerHour == 0 ? "darkred" : "#29C68A",
                            fillOpacity: .6,
                            rotation: new_rotation
                          }
                    } else {
                      marker.icon.rotation = new_rotation;
                    }
                  }
                }
              }, delay * ind
          );
        })(i)
      }
    },
    mapSymbol(color) {
      return {
        path: "M-1.547 12l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM0 0q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
        fillColor: color,
        fillOpacity: 0.6,
        strokeWeight: 0,
        rotation: 0,
        scale: 1.5,
      }
    },
    arrowSymbol(loc) {
      if (this.icon_mode === 'bus') {
        return this.busSymbol(loc)
      }
      return {
        path: (loc.speedMilesPerHour == 0 || loc.headingDegrees == 0) ? "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0" : "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
        scale: 1.5,
        strokeColor: "white",
        strokeStyle: "bold",
        fillColor: loc.speedMilesPerHour == 0 ? "darkred" : "#29C68A",
        fillOpacity: 1,
        rotation: Number(loc.headingDegrees)
      }
    },
    busSymbol(loc) {
      // SVG path for a bus icon: top-down view of a bus
      // Green bus if moving, red bus if stopped
      const isMoving = loc.speedMilesPerHour > 0
      const fillColor = isMoving ? "#29C68A" : "darkred"
      
      // Bus icon: top-down view of a bus
      // Points upward (0 degrees) - front is at top
      // Single continuous path that creates a bus shape
      // Rectangular body with rounded front, showing windows
      const busPath = "M -12,-7 L 10,-7 L 12,-5 L 12,5 L 10,7 L -12,7 Z " + // Main body
                     "M -10,-5 L 8,-5 L 8,5 L -10,5 Z " + // Window frame
                     "M -8,-4 L -5,-4 L -5,4 L -8,4 Z " + // Window 1
                     "M -3,-4 L 0,-4 L 0,4 L -3,4 Z " + // Window 2
                     "M 2,-4 L 5,-4 L 5,4 L 2,4 Z" // Window 3
      
      return {
        path: busPath,
        scale: 1.3,
        strokeColor: "white",
        strokeWeight: 2,
        fillColor: fillColor,
        fillOpacity: 1,
        rotation: (Number(loc.headingDegrees) + 270) % 360
      }
    },
    pinSymbol(color) {
      return {
        path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
        fillColor: color,
        fillOpacity: 1,
        strokeColor: 'black',
        strokeWeight: 1,
        scale: 1.5,
      };
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    filter_items() {
      this.items = this.items_full
      this.markers_new = this.markers_full
      if (this.selected_route_name != '') {
        const field = this.filter_type === 'vehicle' ? 'name' : 'route_name'
        const markerField = this.filter_type === 'vehicle' ? 'bus_name' : 'route_name'
        const match = this.filter_type === 'vehicle' ? this.exact : this.contains
        this.items = this.items.filter(item => match(item[field], this.selected_route_name))
        this.markers_new = this.markers_new.filter(item => match(item[markerField], this.selected_route_name))
      }
      this.markers = this.markers_new
    },
    exact(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase() === val2.toLowerCase();
      }
      return false;
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    }
  },
  computed: {
    sidebarModes() {
      return ['bookingType', 'orgName', 'routes', 'clientID', 'routeSearch', 'routeID']
    }
  },
  watch: {
    selected_route_name(val) {
      this.filter_items()
    },
    '$pageVisibility.hidden'(newVal, oldVal) {
      if (oldVal && !newVal) {
        this.resetTimerAndReload();
      }
    }
  }
}
</script>
<style scoped>

.vmt-center-message {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  font-size: 20px;
  font-weight: bold;
  min-height: 60vh;
}

.vmt-submessage {
  font-size: 15px;
  font-weight: normal;
  color: #666;
  margin-top: 10px;
}

@media (max-width: 480px) {
  .vmt-center-message {
    font-size: 17px;
  }
}

.tracking-label {
  opacity: 0.8;
  font-size: 12px;
  bottom: 35px;
  position: relative;
  border: 1px solid black;
  background-color: #333;
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}

.addr-label {
  opacity: 0.8;
  font-size: 12px;
  bottom: -45px;
  position: relative;
  border: 1px solid black;
  background-color: var(--fi-rail-accent);
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}
.addr-label-1 {
  opacity: 0.8;
  font-size: 12px;
  bottom: -45px;
  position: relative;
  border: 1px solid black;
  background-color: var(--fi-rail-accent);
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}
.addr-label-2 {
  opacity: 0.8;
  font-size: 12px;
  bottom: -68px;
  position: relative;
  border: 1px solid black;
  background-color: var(--fi-rail-accent);
  color: white !important;
  border-radius: 2px;
  padding: 2px;
}
</style>
